import { Component, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_CONFIG, ConfigService } from '@services/config.service';
import { AuthenticationService } from '@services/authentication.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
  standalone: false,
})
export class IframeComponent {
  public url: SafeResourceUrl = '';

  private origin = '';
  private path = '';
  private finishLoading = false;
  private retryLogin = 0; // use for remove infinite loop with old BO
  private onlyUpdateRoute = false;
  private lastFrameRoute = '#/search';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly configService: ConfigService,
    private readonly userService: UserService,
    private readonly authenticationService: AuthenticationService,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.origin = APP_CONFIG.BOoldURL;
    this.retryLogin = 0;
    // main entry for menu action (url change in parent)
    this.route.fragment.subscribe((urlSegments) => {
      if (!this.onlyUpdateRoute) {
        if (urlSegments !== null) {
          this.goTo('#' + urlSegments);
        }
      }
      this.onlyUpdateRoute = false;
    });
  }

  // iframe event listener (url change in iframe)
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  @HostListener('window:message', ['$event']) onMessage(e: any): boolean {
    if (e.origin === origin) {
      // set your origin
      return false;
    }
    this.lastFrameRoute = e.currentTarget?.location?.hash;

    if (e.data) {
      if (e.data.navigateTo === '/login') {
        if (!this.authenticationService.getToken()) {
          this.router.navigateByUrl('/login');
        } else {
          window.frames[0].postMessage(
            {
              token: this.authenticationService.getToken(),
              profile: this.userService.userSubject.value,
            },
            '*',
          );
        }
      }
      if (e.data.navigateTo === '#/login' && this.authenticationService.getToken()) {
        this.checkIfNeedLogin(this.lastFrameRoute); // need login from iframe
      }
      if (e.data.navigateTo) {
        if (e.data.navigateTo !== this.path) {
          this.onlyUpdateRoute = true;
        }
        if (e.data.message === 'noNavigateByUrl') {
          // use for force navigation
          this.router.navigate([e.data.navigateTo]);
        } else {
          this.router.navigateByUrl(e.data.navigateTo);
        }
      }
      if (e.data.message === 'logout') {
        this.authenticationService.clearSession();
        this.router.navigateByUrl('/login');
      }
      if (e.data.message === 'finishLoading') {
        window.frames[0].postMessage(
          {
            hideMenu: true,
            url: this.url,
            lang: this.configService.getCurrentLanguage(),
            token: this.authenticationService.getToken(),
            profile: this.userService.userSubject.value,
          },
          '*',
        );
      }
    }

    return true;
  }

  goTo(path: string): void {
    this.path = path;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.origin + path);
    // this.url = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost:3000' + path); // local testing
  }

  checkIfNeedLogin(redirectTo: string = '#/search'): void {
    if (this.retryLogin < 2 && !this.authenticationService.isTokenExpired(this.authenticationService.getToken())) {
      this.retryLogin = this.retryLogin + 1;
      this.goTo(redirectTo);
    } else {
      this.retryLogin = 0;
      this.authenticationService.clearSession();
      setTimeout(() => {
        // give time to the old BO for delete storage
        window.location.href = '/login';
      }, 500);
    }
  }
}
